import React from 'react';

function Attribution() {
  return (
    <footer className="attribution"
      style={{
        backgroundImage: `url(https://s3.amazonaws.com/www.codeflex.lat/documentos/a423d4ef-3dfb-40a1-9b02-d74ec10e9329/codeflex.jpg)`,
        backgroundSize: '100%',
        backgroundRepeat: "no-repeat",
      }}>
      <p>
        Desarrollado por
        <a href="https://www.codeflex.com.co" target="_blank" rel="noreferrer">&nbsp;Codeflex S.A.S.</a>
      </p>
    </footer>
  );
}

export default Attribution;
